export default "__VITE_ASSET__A1HioAuv__"